import { useMutation, useQueryClient } from 'react-query';

import { UpdateDocChronDocRequestDto } from '../../../../backend/src/case/chronology/doc-chronology/dto/update-doc-chron-doc-request.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateDocChronologyDocParameters extends UpdateDocChronDocRequestDto {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
  docId: string;
}

interface HookProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpdateDocChronologyDoc = ({ onSuccess, onError }: HookProps = {}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ matterId, subsetId, docChronologyId, docId, summary, dateText, title }: UpdateDocChronologyDocParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          summary,
          dateText,
          title,
        } satisfies UpdateDocChronDocRequestDto,
      });

      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}/docs/${docId}`,
        fetchConfig,
      );

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([QueryEntity.DocChronologyDocs, { docChronologyId: variables.docChronologyId }]);
        onSuccess?.();
      },
      onError: (error: Error) => {
        onError?.(error);
      },
    },
  );
};
